import { render, staticRenderFns } from "./CandidateUserReport.vue?vue&type=template&id=118c952a&scoped=true&"
import script from "./CandidateUserReport.vue?vue&type=script&lang=js&"
export * from "./CandidateUserReport.vue?vue&type=script&lang=js&"
import style0 from "./CandidateUserReport.vue?vue&type=style&index=0&id=118c952a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c952a",
  null
  
)

export default component.exports